import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  background: 'linear-gradient(to top, #fff 20%, rgba(255,255,255,0.9) 30%)',
  bottom: 0,
  boxSizing: 'border-box',
  justifySelf: 'flex-end',
  padding: theme.spacing(3),
  position: 'absolute',
  width: '100%',
  zIndex: 2,
}));
